module.exports = __webpack_public_path__ + "img/2021_09_dande_heianjingu_fin_web.fb1399c7.png";